import AbstractService from "./AbstractService";
import types from "../store/types";

export default class TypeService extends AbstractService {

    constructor() {
        super();
    }

    async fetchAndStore() {
        const {code, body} = await this.request.get(this.config.apiUrl + "/v1/types");

        if (code === 200) {
            await this.store.commit(types.TYPES, body["hydra:member"]);
            return true;
        }

        return false;
    }

}